import IntensityChart from './IntensityChart';
export default IntensityChart;
